/* Daddy's Girl Collection — accessible gift finder using real catalog links. */
(function () {
  'use strict';
  function mount(root) {
    (root || document).querySelectorAll('[data-bond-finder]').forEach(function (section) {
      if (section.dataset.bound === '1') return;
      section.dataset.bound = '1';
      var form = section.querySelector('[data-bond-form]');
      var catalog = Array.from(section.querySelectorAll('[data-bond-product]'));
      var output = section.querySelector('[data-bond-results]');
      var status = section.querySelector('[data-bond-status]');
      var browse = section.querySelector('[data-bond-browse]');
      if (!form || !output || !status) return;
      var urls = { dad: '/collections/girl-dad', gift: '/collections/gifts-from-daughter-to-dad', together: '/collections/dad-daughter' };
      function unique(items) {
        var seen = new Set();
        return items.filter(function (card) { var key = card.dataset.key; if (seen.has(key)) return false; seen.add(key); return true; });
      }
      function matches(item, style, occasion) {
        var text = (item.dataset.search || '').toLowerCase();
        var matchStyle = style === 'any' ||
          (style === 'funny' && /funny|joke|humor|scare|farter|laugh|silly|sarcas/.test(text)) ||
          (style === 'heartfelt' && /love|daughter|dad|hero|proud|awesome|heart|father/.test(text)) ||
          (style === 'retro' && /retro|vintage|classic|groovy|90s|70s|throwback/.test(text));
        var matchOccasion = occasion === 'any' ||
          (occasion === 'fathers' && /father.s day|father day|dad gift|fathers day/.test(text)) ||
          (occasion === 'birthday' && /birthday/.test(text));
        return matchStyle && matchOccasion;
      }
      function render(ev) {
        if (ev) ev.preventDefault();
        var who = form.elements.who.value;
        var style = form.elements.style.value;
        var occasion = form.elements.occasion.value;
        var budget = form.elements.budget.value;
        var group = who === 'gift' ? '2' : (who === 'together' ? '3' : '1');
        var eligible = unique(catalog.filter(function (p) {
          var price = Number(p.dataset.price);
          return p.dataset.group === group && (budget === 'any' || (Number.isFinite(price) && price < Number(budget)));
        }));
        var exact = eligible.filter(function (p) { return matches(p, style, occasion); });
        output.replaceChildren();
        if (exact.length) {
          exact.slice(0, 4).forEach(function (p) { output.appendChild(p.cloneNode(true)); });
          status.textContent = 'Showing ' + Math.min(exact.length, 4) + ' real matching design' + (Math.min(exact.length, 4) === 1 ? '' : 's') + '. Select a product for exact size, color and price.';
        } else {
          status.textContent = 'No exact match for this combination. Try a different style, occasion, or budget, or browse the collection below.';
        }
        if (browse) browse.href = urls[who] || '/collections/gift-ideas';
      }
      form.addEventListener('submit', render);
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

/* Shopify-native predictive search enhancement: standard search stays usable without JS. */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('.am-search, .am-mobile-search form').forEach(function (form, index) {
      if (form.dataset.bondSearch === '1') return;
      var input = form.querySelector('input[type="search"][name="q"]');
      if (!input) return;
      form.dataset.bondSearch = '1';
      var host = form.closest('.am-header__main') || form.closest('.am-mobile-search');
      if (!host) return;
      var panel = document.createElement('div');
      panel.className = 'bond-predictive';
      panel.hidden = true;
      panel.setAttribute('aria-label', 'Product suggestions');
      panel.setAttribute('role', 'region');
      panel.id = 'bond-predictive-' + index;
      host.appendChild(panel);
      input.setAttribute('aria-controls', panel.id);
      var timer = null;
      var pending = null;
      function hide() { panel.hidden = true; panel.replaceChildren(); }
      async function suggest(term) {
        if (pending) pending.abort();
        if (term.length < 2) { hide(); return; }
        pending = new AbortController();
        var params = new URLSearchParams({ q: term, 'resources[type]': 'product', 'resources[limit]': '5' });
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          var response = await fetch(rootUrl + 'search/suggest.json?' + params.toString(), { signal: pending.signal, credentials: 'same-origin' });
          if (!response.ok) { hide(); return; }
          var data = await response.json();
          if (input.value.trim() !== term) return;
          var products = ((data || {}).resources || {}).results?.products || [];
          panel.replaceChildren();
          if (!products.length) { hide(); return; }
          var caption = document.createElement('p');
          caption.className = 'bond-predictive__label';
          caption.textContent = 'PRODUCT SUGGESTIONS';
          panel.appendChild(caption);
          products.forEach(function (product) {
            var link = document.createElement('a');
            link.className = 'bond-predictive__item';
            link.href = product.url;
            if (product.featured_image && product.featured_image.url) {
              var image = document.createElement('img');
              image.src = product.featured_image.url;
              image.width = 54;
              image.height = 54;
              image.loading = 'lazy';
              image.alt = '';
              link.appendChild(image);
            }
            var title = document.createElement('span');
            title.textContent = product.title;
            link.appendChild(title);
            panel.appendChild(link);
          });
          panel.hidden = false;
        } catch (error) { if (error.name !== 'AbortError') hide(); }
      }
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var term = input.value.trim();
        timer = setTimeout(function () { suggest(term); }, 220);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      document.addEventListener('click', function (e) { if (!host.contains(e.target)) hide(); });
      form.addEventListener('submit', function () { hide(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
